import gql from "graphql-tag";

export default gql`
  fragment CommentOrReplyAuthorFields on User {
    _id
    email
    firstName
    lastName
    fullName
    pictureUrl
    isSiteAdmin
    isBlack
  }
`;
